"use client"

import TablaRrhhAsistenciaComponent from "./TablaRrhhAsistenciaComponent.js"

const RrhhAsistenciaComponent = () => {
  return <TablaRrhhAsistenciaComponent />
}

export default RrhhAsistenciaComponent
